export const SUB_STEP_ALIAS = {
  1: 'mobile',
  2: 'addTickets',
  final: 2, // to indicate the sub step no of final step
};

export const FIRST_STEP_PROGRESS = 33.33;